import { ComponentProps } from "react";
import classNames from "classnames";
import styled from "styled-components";

type ButtonGroupProps = ComponentProps<"div">;

export const ButtonGroup = styled(({ children, className }: ButtonGroupProps) => {
  return <div className={classNames(className, "flex flex-wrap space-y-3 sm:space-y-0 sm:space-x-3")}>{children}</div>;
})``;
